module.exports = __webpack_public_path__ + "static/media/pfg-logo.165e65d9.png";